const containerStyleProps = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
} as const;

const targetStyleProps = {
  // This is needed to make the styles work, but it will be overridden by flex growth as this element is the only child.
  height: '1px',
  flexGrow: 1,

  // In combination with the above trick, this will make this element fill its parent, without causing it to grow.
  position: 'relative',

  // Now that we've filled the available space, just slap a scrollbar on the rest.
  overflow: 'auto',
} as const;

export const expandToFillParentStyles = {
  containerStyleProps,
  targetStyleProps,
};
